/*
Takes any string value and converts it to all uppercase Alphanumeric and underscores
anything else a default value is returned.
*/
export const formatDataTestId = dataTestValue => {
  const defaultValue = 'DataTestIdGoesHere';
  const validTypes = { string: true, number: true };
  if (!validTypes[typeof dataTestValue]) return defaultValue;

  const reg = /\W+/g;
  const simpleStrings = dataTestValue
    .toString()
    .trim()
    .toUpperCase()
    .replaceAll(reg, '');

  return simpleStrings || defaultValue;
};
